import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=4f88eea0&scoped=true"
import script from "./EditBrand.vue?vue&type=script&lang=js"
export * from "./EditBrand.vue?vue&type=script&lang=js"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=4f88eea0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88eea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f88eea0')) {
      api.createRecord('4f88eea0', component.options)
    } else {
      api.reload('4f88eea0', component.options)
    }
    module.hot.accept("./EditBrand.vue?vue&type=template&id=4f88eea0&scoped=true", function () {
      api.rerender('4f88eea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/brandlist/EditBrand.vue"
export default component.exports